( function ( windowObject, documentObject, config ) {
	'use strict';

	if ( ! windowObject || ! documentObject ) {
		return;
	}

	function initBakerySelect() {
		if (
			! windowObject.SweettySpaceSelect ||
			! windowObject.SweettySpaceSelect.initRemoteBakerySelect
		) {
			return;
		}

		windowObject.SweettySpaceSelect.initRemoteBakerySelect(
			'.js-catalog-bakery-select',
			Object.assign( {}, config || {}, {
				sourceGroup: 'catalog_search',
			} )
		);
	}

	function initCitySelect() {
		if (
			! windowObject.SweettySpaceSelect ||
			! windowObject.SweettySpaceSelect.initSimpleSelect2
		) {
			return;
		}

		windowObject.SweettySpaceSelect.initSimpleSelect2(
			'.select2-init-field'
		);
	}

	documentObject.addEventListener( 'DOMContentLoaded', function () {
		initBakerySelect();
		initCitySelect();
	} );
} )( window, document, window.SweettySpaceCatalogFilters );
